import { useEffect, useState } from "react";
import { Box, Image, Text, Heading } from "@chakra-ui/react";

import { wisp } from "../lib/wispAbout";

import { Button } from "../components/ui/button";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { PaginationControl } from "../components/PaginationControl";
import { SEO } from "../components/SEO";
import StructuredData from "../components/SEO/StructuredData";

import AboutImage from "../assets/images/aboutImage.png";

export const About = () => {
  const [newsBlog, setNewsBlog] = useState<any[]>([]);

  const [currentPage, setCurrentPage] = useState<number>(1);

  const [pagination, setPagination] = useState<any>();

  useEffect(() => {
    const getNewsBlog = async () => {
      const result = await wisp.getPosts({ limit: 3, page: currentPage });

      setPagination(result.pagination);

      setNewsBlog(result.posts);
    };

    getNewsBlog();
  }, [currentPage]);

  return (
    <Box>
      <SEO 
        title="About Udobong Ntia | Professional Profile"
        description="Udobong Ntia is a seasoned Project Executive and former Executive Director at ExxonMobil, with a distinguished career in the oil and energy industry."
        canonicalUrl="https://udobongntia.com/about"
        keywords={['Udobong Ntia', 'ExxonMobil Executive', 'Project Executive', 'Oil and Gas Industry', 'Energy Leadership', 'Professional Profile', 'NNPC']}
      />
      <StructuredData 
        type="Person" 
        data={{
          jobTitle: 'EVP Upstream at NNPC',
          description: 'Udobong Ntia is a seasoned Project Executive with a distinguished career in the oil and energy industry.'
        }}
      />
      <Header />

      <Box
        maxW={"790px"}
        minH={"100vh"}
        borderLeftWidth={"1px"}
        borderRightWidth={"1px"}
        borderColor={"#E7E8E9"}
        justifySelf={"center"}
        px={{ base: "16px", lg: "95px" }}
        pt={{ base: "140px", lg: "191px" }}
        pb="41px"
      >
        <Box fontFamily={"Raleway"}>
          <Heading
            fontSize={{ base: "28px", lg: "38px" }}
            fontWeight={600}
            color={"#101720"}
            fontFamily={"BricolageGrotesque"}
            lineHeight={"140%"}
          >
            Passion, Purpose, Transformation
          </Heading>

          <Text
            fontSize={{ base: "16px", lg: "19px" }}
            fontWeight={500}
            color={"#667085"}
            lineHeight={"140%"}
            mt="24px"
          >
            Udobong Ntia is a seasoned Project Executive and former Executive
            Director at ExxonMobil, with a distinguished career in the oil and
            energy industry.
          </Text>

          <Text
            fontSize={{ base: "16px", lg: "19px" }}
            fontWeight={500}
            color={"#667085"}
            lineHeight={"140%"}
            mt="24px"
          >
            He brings extensive expertise in petroleum and gas, underpinned by a
            strong track record in business development. Udobong holds an MBA in
            Business Administration and Management from the University of
            Houston.
          </Text>

          <Text
            fontSize={{ base: "16px", lg: "19px" }}
            fontWeight={500}
            color={"#667085"}
            lineHeight={"140%"}
            mt="24px"
          >
            During his tenure at ExxonMobil, he served as General Manager of
            External Relations & Business Development, overseeing Venture
            Relations, Public & Government Affairs, and Commercial/Gas & Power
            Marketing.
          </Text>

          <Text
            fontSize={{ base: "16px", lg: "19px" }}
            fontWeight={500}
            color={"#667085"}
            lineHeight={"140%"}
            mt="24px"
          >
            From 2009 to 2010, he held the position of Area Operations Manager,
            where he led the overall asset management and safe operations of
            four major offshore production facilities and their associated
            pipeline network to onshore terminals.
          </Text>

          <Text
            fontSize={{ base: "16px", lg: "19px" }}
            fontWeight={500}
            color={"#667085"}
            lineHeight={"140%"}
            mt="24px"
          >
            In this role, he was responsible for the efficient depletion of 2.5
            billion barrels of proven reserves, prudent oversight of $200
            million in annual operating costs, and safe production of 150,000
            barrels of crude oil per day. His leadership ensured operational
            excellence in a complex fiscal and regulatory landscape.
          </Text>
        </Box>

        <Image 
          src={AboutImage} 
          alt="Udobong Ntia - Professional headshot" 
          my="53px" 
        />

        <Box>
          <Heading
            fontSize={{ base: "28px", lg: "33px" }}
            fontWeight={600}
            color={"#101720"}
            textAlign={"center"}
            fontFamily={"BricolageGrotesque"}
          >
            In the News
          </Heading>

          <Box mb="44px">
            {newsBlog.map((blogPost) => (
              <Box
                key={blogPost.id}
                mt="40px"
                borderRadius={"32px"}
                borderWidth={"1.5px"}
                borderColor={"#E7E8E9"}
                p="20px"
                bg="#FAFAFA"
              >
                <Image
                  src={blogPost.image}
                  alt={`${blogPost.title} - Udobong Ntia news article`}
                  objectFit={"cover"}
                  w="100%"
                  borderRadius={"15px"}
                />

                <Heading
                  my="23px"
                  fontSize={{ base: "21px", lg: "33px" }}
                  fontWeight={600}
                  color={"black"}
                  lineHeight={"140%"}
                  fontFamily={"BricolageGrotesque"}
                >
                  {blogPost.title}
                </Heading>

                <Button
                  bg="#E7E8E9"
                  borderWidth={0}
                  color={"#101720"}
                  fontFamily={"Raleway"}
                  onClick={() => window.open(blogPost.description, "_blank")}
                >
                  Read More
                </Button>
              </Box>
            ))}
          </Box>

          <PaginationControl
            currentPage={currentPage}
            totalPages={pagination?.totalPages}
            onPageChange={setCurrentPage}
          />

          <Footer />
        </Box>
      </Box>
    </Box>
  );
};
